const basicDetailsSchema = Object.seal({
    feilds: [{
        id: 1,
        name: 'counselling_date',
        title: 'Date of Counselling *',
        visible: true,
        element: 'datepicker',
        required: false,
        type: 'text',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Date of Counselling'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 1,
        name: 'token_number',
        title: 'Token Number *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Token Number'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 12,
        name: 'counselling_type',
        title: 'Counselling Type *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Counselling Type'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 13,
        name: 'ip_number',
        title: 'IP Number',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 7,
        name: 'umr_number',
        title: 'UMR Number *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter UMR Number'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 2,
        name: 'patient_name',
        title: 'Patient name *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 3,
        name: 'age',
        title: 'Age *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 4,
        name: 'gender',
        title: 'Gender *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'phone_number',
        title: 'Phone Number *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 14,
        name: 'marital_status',
        title: 'Marital Status',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 9,
        name: 'doctor_name',
        title: 'Doctor Name *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 10,
        name: 'speciality',
        title: 'Speciality *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 15,
        name: 'address',
        title: 'Address',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-9 mt-3'
    }, {
        id: 16,
        name: 'payment_mode',
        title: 'Mode of Payment *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    },]
})

const InsuranceDetailsSchema = Object.seal({
    feilds: [{
        id: 1,
        name: 'estimated_admission_date',
        title: 'Estimated Date of Admission*',
        visible: true,
        element: 'datepicker',
        required: false,
        type: 'datepicker',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value !== '');
            },
            message: 'Select Estimated Date Of Admission'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 2,
        name: 'actual_admission_date',
        title: 'Actual Date of Admission',
        visible: false,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    },
    {
        id: 3,
        name: 'diagnosis',
        title: 'Diagnosis',
        visible: false,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    },  
    {
        id: 4,
        name: 'type_of_patient',
        title: 'Type Of Patient *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Select Type Of Patient'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 5,
        name: 'type_insurance',
        title: 'Type Of Insurance *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Select Type Of Insurance'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3',
        ref:'this.type_insurance'
    }, {
        id: 6,
        name: 'insurance_status',
        title: 'Insurance Status *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Select Insurance Status'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 7,
        name: 'reason_if_denied',
        title: 'Denied Reason*',
        visible: false,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Reason'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'tpa_name',
        title: 'TPA Name *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Select TPA'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 9,
        name: 'insurance_company_name',
        title: 'Insurance Company Name *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Select ICN'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 10,
        name: 'policy_no',
        title: 'Policy Number',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 11,
        name: 'employer_name_company',
        title: 'Employer Name (Company) *',
        visible: false,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Employer Name'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 12,
        name: 'care_management',
        title: 'Care Management *',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Select Care Management'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 13,
        name: 'estimate_type',
        title: 'Estimate Type *',
        visible: false,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Select Estimate Type'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    },  {
        id: 14,
        name: 'date_of_surgery',
        title: 'Date Of Surgery *',
        visible: false,
        element: 'datepicker',
        required: false,
        type: 'datepicker',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Enter Date'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 15,
        name: 'ins_surgery_procedure_name',
        title: 'Surgery / Procedure Name *',
        header: 11,
        sub_header: 20,
        visible: false,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Select Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 16,
        name: 'ins_surgery_procedure_amount',
        title: 'Surgery / Procedure Amount',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    },{
        id: 17,
        name: 'ins_surgery_percent',
        title: 'Surgery / Procedure (%)',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    },{
        id: 18,
        name: 'ins_package_name',
        title: 'Package Name *',
        visible: false,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Package Name'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 19,
        name: 'icu_stay',
        title: 'ICU Stay (Days)',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 20,
        name: 'room_stay',
        title: 'Room Stay (Days)',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 21,
        name: 'length_of_stay',
        title: 'Length Of Stay *',
        visible: true,
        element: 'input',
        required: true,
        type: 'number_normal',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Enter Length of Stay'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    },]
})

const estimateBreakupFormatSchema = Object.seal({
    feilds: [{
        id: 1,
        name: 'base_price',
        title: 'Base Price',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 2,
        name: 'excludes',
        title: 'Excludes',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    },
    {
        id: 5,
        name: 'initial_amount',
        title: 'Initial Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    },{
        id: 5,
        name: 'co_pay_amount',
        title: 'Co Pay Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 6,
        name: 'estimated_nme_amount',
        title: 'Estimated NME Amount *',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value > 0 && value != '');
            },
            message: 'Please Enter Estimated NME Amount'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 7,
        name: 'actual_nme_amount',
        title: 'Actual NME Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 8,
        name: 'final_bill_amount',
        title: 'Final Bill Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 9,
        name: 'discount',
        title: 'Discount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 10,
        name: 'final_approval_amount',
        title: 'Final Approval Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 11,
        name: 'extra_deduction_amount',
        title: 'Extra Deduction Amount',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 12,
        name: 'remarks',
        title: 'Remarks *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value > 0 && value != '');
            },
            message: 'Please Enter Remarks '
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 13,
        name: 'difference_amount',
        title: 'Difference Amount *',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value > 0 && value != '');
            },
            message: 'Please Enter Amount'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 14,
        name: 'ins_total_estimate_amount',
        title: 'Total Estimate amount',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }, {
        id: 16,
        name: 'signature_of_patient_attendant',
        title: 'Signature of ',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules:  [
        //     {
        //     test: (value) => {
        //         return (value !== null && value.length > 0 && value != '');
        //     },
        //     message: 'Please Select Signature'
        // }
    ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 17,
        name: 'attendant_name',
        title: 'Attendant name *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value > 0 && value != '');
            },
            message: 'Please Enter Attendant Name '
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 18,
        name: 'relation',
        title: 'Relation *',
        visible: true,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value > 0 && value != '');
            },
            message: 'Please Enter Relation'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 15,
        name: 'Signature_of_FC',
        title: 'Signature of FC',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }, {
        id: 16,
        name: 'Name_of_the_FC',
        title: 'Name of the FC',
        visible: false,
        element: 'input',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mt-3'
    }]
})

const addonSchema = {
    feilds: [{
        id: 1,
        name: 'room_charges',
        header: 1,
        header_amount: 0,
        title: 'Room charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'room',
                'feilds': [{
                    id: 1,
                    service: 1,
                    sub_header: 1,
                    name: 'room',
                    title: 'Room',
                    visible: true,
                    element: 'text',
                    row_group: 'room',
                    table: 'room_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Room Charges Qty.',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Charges Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'room_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Room Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'room_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Room Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'room',
                    table: 'room_charges',
                }]
            }, {
                'id': 2,
                'key_word': 'icu',
                'feilds': [{
                    id: 1,
                    service: 2,
                    sub_header: 2,
                    name: 'icu',
                    title: 'ICU',
                    visible: true,
                    element: 'text',
                    row_group: 'icu',
                    table: 'room_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'ICU Charges Qty.',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Charges Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'icu',
                    table: 'room_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'ICU Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'icu',
                    table: 'room_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'ICU Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'icu',
                    table: 'room_charges',
                }]
            }, 
            // {
            //     'id': 3,
            //     'key_word': 'intensivist',
            //     'feilds': [{
            //         id: 1,
            //         service: 3,
            //         sub_header: 3,
            //         name: 'intensivist',
            //         title: 'Intensivist',
            //         visible: true,
            //         element: 'text',
            //         row_group: 'intensivist',
            //         table: 'room_charges',
            //     }, {
            //         id: 2,
            //         name: 'qty',
            //         title: 'Intensivist Charges Qty.',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'number',
            //         placeholder: 'Intensivist Charges Quantity',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: true,
            //         className: 'col-3',
            //         row_group: 'intensivist',
            //         table: 'room_charges',
            //     }, {
            //         id: 2,
            //         name: 'rate',
            //         title: 'Intensivist Charges Rate',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'number',
            //         placeholder: 'Intensivist Charges Rate',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: true,
            //         className: 'col-3',
            //         row_group: 'intensivist',
            //         table: 'room_charges',
            //     }, {
            //         id: 2,
            //         name: 'amount',
            //         title: 'Intensivist Charges Amount',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'number',
            //         placeholder: 'Intensivist Charges Amount',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: true,
            //         className: 'col-3',
            //         row_group: 'intensivist',
            //         table: 'room_charges',
            //     }]
            // },
            // {
            //     'id': 4,
            //     'key_word': 'asst_intensivist',
            //     'feilds': [{
            //         id: 1,
            //         service: 4,
            //         sub_header: 4,
            //         name: 'asst_intensivist',
            //         title: 'Asst. Intensivist',
            //         visible: true,
            //         element: 'text',
            //         row_group: 'asst_intensivist',
            //         table: 'room_charges',
            //     }, {
            //         id: 2,
            //         name: 'qty',
            //         title: 'Asst. Intensivist Charges Qty.',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'number',
            //         placeholder: 'Asst. Intensivist Charges Quantity',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: true,
            //         className: 'col-3',
            //         row_group: 'asst_intensivist',
            //         table: 'room_charges',
            //     }, {
            //         id: 2,
            //         name: 'rate',
            //         title: 'Asst. Intensivist Charges Rate',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'number',
            //         placeholder: 'Asst. Intensivist Charges Rate',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: true,
            //         className: 'col-3',
            //         row_group: 'asst_intensivist',
            //         table: 'room_charges',
            //     }, {
            //         id: 2,
            //         name: 'amount',
            //         title: 'Asst. Intensivist Charges Amount',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'number',
            //         placeholder: 'Asst. Intensivist Charges Amount',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: true,
            //         className: 'col-3',
            //         row_group: 'asst_intensivist',
            //         table: 'room_charges',
            //     }]
            // }
        ],
            'add_more_feilds': [],
        }
    }, {
        id: 2,
        name: 'room_investigation_charges',
        header: 2,
        header_amount: 0,
        title: 'Room Investigation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend Room Investigation',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'text': 'Routine',
                'key_word':'routine',
                'type': 'text',
                'key_word': 'routine',
                'input_feild': [],
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 2,
                    sub_header: 5,
                    name: 'Routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    tooltip:null,
                    table: 'room_investigation_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'w-100',
                    row_group: 'routine',
                    table: 'room_investigation_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Room Investigation Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'room_investigation_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Room Investigation Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Room Investigation Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'room_investigation_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'room_investigation_charges',
                },]
            },
            {
                'id': 2,
                'text': 'Highend',
                'type': 'text',
                'key_word': 'highend',
                'input_feild': [],
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 2,
                    sub_header: 6,
                    name: 'ins_room_highend_investigations',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Room Investigation',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12 p-0',
                    row_group: 'highend',
                    table: 'room_investigation_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Room Investigation Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'w-100',
                    row_group: 'highend',
                    table: 'room_investigation_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Room Investigation Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Room Investigation Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'room_investigation_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Room Investigation Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Room Investigation Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'room_investigation_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'room_investigation_charges',
                },]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 2,
                sub_header: 6,
                name: 'ins_room_highend_investigations',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend Room Investigation',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'room_investigation_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend Room Investigation Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'room_investigation_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend Room Investigation Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'room_investigation_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend Room Investigation Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Room Investigation Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'room_investigation_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'room_investigation_charges',
            }],
        }
    }, {
        id: 3,
        name: 'icu_investigation_charges',
        header: 3,
        header_amount: 0,
        title: 'ICU Investigation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend ICU Investigation',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'text': 'Routine',
                'type': 'text',
                'key_word': 'routine',
                'input_feild': [],
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 3,
                    sub_header: 7,
                    name: 'Routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    tooltip:null,
                    table: 'icu_investigation_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine ICU Investigation Quantity',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'w-100',
                    row_group: 'routine',
                    table: 'icu_investigation_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine ICU Investigation Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine ICU Investigation Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'icu_investigation_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine ICU Investigation Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine ICU Investigation Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'icu_investigation_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'icu_investigation_charges',
                },]
            },
            {
                'id': 2,
                'text': 'Highend',
                'type': 'text',
                'key_word': 'highend',
                'input_feild': [],
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 3,
                    sub_header: 8,
                    name: 'ins_icu_highend_investigations',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend ICU Investigation',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12 p-0',
                    row_group: 'highend',
                    table: 'icu_investigation_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend ICU Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'w-100',
                    row_group: 'highend',
                    table: 'icu_investigation_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend ICU Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend ICU Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_investigation_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend ICU Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend ICU Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_investigation_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'icu_investigation_charges',
                },]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 3,
                sub_header: 8,
                name: 'ins_icu_highend_investigations',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend ICU Investigation',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'icu_investigation_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend ICU Investigation Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend ICU Investigation Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_investigation_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend ICU Investigation Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend ICU Investigation Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_investigation_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend ICU Investigation Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend ICU Investigation Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_investigation_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'icu_investigation_charges',
            }],
        }
    }, {
        id: 4,
        name: 'ip_pharmacy_charges',
        header: 4,
        header_amount: 0,
        title: 'IP Pharmacy charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend Drugs & Implants',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 4,
                    sub_header: 9,
                    name: 'routine_drugs_implants',
                    title: 'Routine Drugs & Implants',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    tooltip:null,
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Drugs & Implants',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Drugs & Implants Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Drugs & Implants Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'ip_pharmacy_charges',
                }]
            }, {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 4,
                    sub_header: 10,
                    name: 'ins_room_highend_drugs_implants',
                    title: 'Highend Drugs & Implants',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Drugs & Implants',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Highend Drugs & Implants Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Drugs & Implants Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Drugs & Implants Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ip_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'ip_pharmacy_charges',
                }]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 4,
                sub_header: 10,
                name: 'ins_room_highend_drugs_implants',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend Drugs & Implants',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'ip_pharmacy_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend Drugs & Implants Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs & Implants Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ip_pharmacy_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend Drugs & Implants Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs & Implants Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ip_pharmacy_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend Drugs & Implants Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs & Implants Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ip_pharmacy_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'ip_pharmacy_charges',
            }]
        }
    }, {
        id: 5,
        name: 'icu_pharmacy_charges',
        header: 5,
        header_amount: 0,
        title: 'ICU Pharmacy charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend Drugs & Implants',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 5,
                    sub_header: 11,
                    name: 'routine_drugs_implants',
                    title: 'Routine Drugs & Implants',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    tooltip:null,
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Drugs & Implants',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants',
                    rules: [],
                    errors: [],
                    value: 0,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Drugs & Implants Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Drugs & Implants Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Drugs & Implants Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'icu_pharmacy_charges',
                }]
            }, {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 5,
                    sub_header: 12,
                    name: 'ins_icu_highend_drugs_implants',
                    title: 'Highend Drugs & Implants',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Drugs & Implants',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Highend Drugs & Implants Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Drugs & Implants Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_pharmacy_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Drugs & Implants Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'icu_pharmacy_charges',
                }, , {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'icu_pharmacy_charges',
                },]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 5,
                sub_header: 12,
                name: 'ins_icu_highend_drugs_implants',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend Drugs & Implants',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'icu_pharmacy_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend Drugs & Implants Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs & Implants Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_pharmacy_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend Drugs & Implants Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs & Implants Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_pharmacy_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend Drugs & Implants Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs & Implants Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'icu_pharmacy_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'icu_pharmacy_charges',
            }]
        }
    }, {
        id: 6,
        name: 'ot_cath_pharmacy',
        header: 6,
        header_amount: 0,
        title: 'OT/Cath Pharmacy',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Highend Drugs & Implants',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 6,
                    sub_header: 13,
                    name: 'routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    tooltip:null,
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'ot_cath_pharmacy',
                },]
            }, {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 6,
                    sub_header: 14,
                    name: 'ins_ot_cath_highend_drugs_implants',
                    title: 'Highend Drugs & Implants',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Highend Drugs & Implants',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Highend Drugs & Implants Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Highend Drugs & Implants Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Highend Drugs & Implants Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Highend Drugs & Implants Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_cath_pharmacy',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'ot_cath_pharmacy',
                },]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 6,
                sub_header: 14,
                name: 'ins_ot_cath_highend_drugs_implants',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Highend Drugs & Implants',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'ot_cath_pharmacy',
            }, {
                id: 1,
                name: 'qty',
                title: 'Highend Drugs & Implants Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs & Implants Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_cath_pharmacy',
            }, {
                id: 1,
                name: 'rate',
                title: 'Highend Drugs & Implants Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs & Implants Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_cath_pharmacy',
            }, {
                id: 1,
                name: 'amount',
                title: 'Highend Drugs & Implants Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Highend Drugs & Implants Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_cath_pharmacy',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'ot_cath_pharmacy',
            }],
        }
    },  
    // {
    //     id: 7,
    //     name: 'ins_drug_admin_charges',
    //     header: 7,
    //     header_amount: 0,
    //     title: 'Drug Admin Charges',
    //     visible: true,
    //     Specification: {
    //         'type': 'table',
    //         'add_more': false,
    //         'add_more_title': null,
    //         'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
    //         'table_body': [{
    //             'id': 1,
    //             'key_word': 'routine',
    //             'feilds': [{
    //                 id: 1,
    //                 service: 1,
    //                 header: 7,
    //                 sub_header: 15,
    //                 name: 'routine',
    //                 title: 'Drug Admin Charges',
    //                 visible: true,
    //                 element: 'text',
    //                 row_group: 'routine',
    //                 table: 'ins_drug_admin_charges',
    //             }, {
    //                 id: 1,
    //                 name: 'qty',
    //                 header: 7,
    //                 sub_header: 15,
    //                 title: 'Routine Quantity',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Routine Quantity',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: false,
    //                 className: 'col-3',
    //                 row_group: 'routine',
    //                 table: 'ins_drug_admin_charges',
    //             }, {
    //                 id: 1,
    //                 name: 'rate',
    //                 title: 'Routine Rate',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Routine Rate',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: true,
    //                 className: 'col-3',
    //                 row_group: 'routine',
    //                 table: 'ins_drug_admin_charges',
    //             }, {
    //                 id: 1,
    //                 name: 'amount',
    //                 title: 'Routine Amount',
    //                 visible: true,
    //                 icon: 'number',
    //                 element: 'input',
    //                 required: true,
    //                 type: 'number',
    //                 placeholder: 'Routine Amount',
    //                 rules: [],
    //                 errors: [],
    //                 value: null,
    //                 valid: false,
    //                 state: '',
    //                 disable: true,
    //                 className: 'col-3',
    //                 row_group: 'routine',
    //                 table: 'ins_drug_admin_charges',
    //             }]
    //         }]
    //     }
    // }
    // , 
    {
        id: 8,
        name: 'general_equipment_charges',
        header: 8,
        header_amount: 0,
        title: 'General Equipment Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title':'Add General Equipment Charges',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" },{ 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 8,
                    sub_header: 35,
                    name: 'routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'general_equipment_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'general_equipment_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'general_equipment_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'general_equipment_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'general_equipment_charges',
                },]
            },
                {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: 1,
                    header: 8,
                    sub_header: 16,
                    name: 'ins_general_highend_equipments',
                    title: 'Equipment Charges',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Equipment Type',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'general_equipment_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Equipment Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Equipment Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'general_equipment_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Equipment Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Equipment Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'general_equipment_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Equipment Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Equipment Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'general_equipment_charges',
                },{
                    id: 2, 
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'general_equipment_charges',
                }]
            }],
            'add_more_feilds': [{
                id: 2,
                service: null,
                header: 8,
                sub_header: 16,
                name: 'ins_general_highend_equipments',
                title: 'Equipment Charges',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Equipment Type',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'general_equipment_charges',
            }, {
                id: 2,
                name: 'qty',
                title: 'Equipment Quantity',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Equipment Quantity',
                rules: [],
                errors: [],
                value: 0,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'general_equipment_charges',
            }, {
                id: 2,
                name: 'rate',
                title: 'Equipment Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Equipment Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'general_equipment_charges',
            }, {
                id: 2,
                name: 'amount',
                title: 'Equipment Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Equipment Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'general_equipment_charges',
            },{
                id: 2,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'general_equipment_charges',
            }
            ],
        }
    }, {
        id: 9,
        name: 'ot_charges',
        header: 9,
        header_amount: 0,
        title: 'OT Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add OT Charges',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [
            {
                'id': 1,
                'key_word': 'ot_inst_disinfec',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 9,
                    sub_header: 18,
                    name: 'ot_inst_disinfec',
                    title: 'OT Instruments + Disinfection',
                    visible: true,
                    element: 'text',
                    row_group: 'ot_inst_disinfec',
                    table: 'ot_charges',
                }, {
                    id: 1,
                    service: null,
                    header: 9,
                    sub_header: 18,
                    name: 'qty',
                    title: 'OT Instruments + Disinfection Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Instruments + Disinfection Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ot_inst_disinfec',
                    table: 'ot_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'OT Instruments + Disinfection Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Instruments + Disinfection Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ot_inst_disinfec',
                    table: 'ot_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'OT Instruments + Disinfection Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Instruments + Disinfection Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ot_inst_disinfec',
                    table: 'ot_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'ot_inst_disinfec',
                    table: 'ot_charges',
                }]
            },
            {
                'id': 2,
                'key_word': 'routine',
                'feilds': [{
                    id: 2,
                    service: 2,
                    header: 9,
                    sub_header: 40,
                    name: 'routine',
                    title: 'Routine OT Hours',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'ot_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_charges',
                    charge: 0,
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'ot_charges',
                },]
            },{
            'id': 3,
            'key_word': 'highend',
            'feilds': [{
                id: 3,
                service: 1,
                header: 9,
                sub_header: 17,
                name: 'ins_ot_hours',
                title: 'Equipment Charges',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Equipment Type',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 3,
                name: 'qty',
                title: 'OT Hours Quantity',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12',
                row_group: 'highend',
                table: 'ot_charges',
                charge: 0,
            }, {
                id: 3,
                name: 'rate',
                title: 'OT Hours Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 3,
                name: 'amount',
                title: 'OT Hours Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 3,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'ot_charges',
            }]
        }],
            'add_more_feilds': [{
                id: 4,
                service: 1,
                header: 9,
                sub_header: 17,
                name: 'ins_ot_hours',
                title: 'Equipment Charges',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Equipment Type',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 4,
                name: 'qty',
                title: 'OT Hours Quantity',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: true,
                className: 'col-12',
                row_group: 'highend',
                table: 'ot_charges',
                charges:0
            }, {
                id: 4,
                name: 'rate',
                title: 'OT Hours Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 4,
                name: 'amount',
                title: 'OT Hours Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Hours Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'ot_charges',
            }, {
                id: 4,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'ot_charges',
            }]
        }
    }, {
        id: 10,
        name: 'ot_equipment',
        header: 10,
        header_amount: 0,
        title: 'OT Equipment',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add OT Equipment',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 10,
                    sub_header: 36 ,
                    name: 'routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'ot_equipment',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: null ,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_equipment',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_equipment',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ot_equipment',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'ot_equipment',
                },]
            }, {
                'id': 1,
                'text': 'OT Equipment',
                'type': 'text',
                'key_word': 'highend',
                'input_feild': [],
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 10,
                    sub_header: 19,
                    name: 'ins_ot_equipments',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'OT Equipment',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12 p-0',
                    row_group: 'highend',
                    table: 'ot_equipment',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'OT Equipment Qty.',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Equipment Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_equipment',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'OT Equipment Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Equipment Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_equipment',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'OT Equipment Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'OT Equipment Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'ot_equipment',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'ot_equipment',
                }]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 10,
                sub_header: 19,
                name: 'ins_ot_equipments',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'OT Equipment',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'routine',
                table: 'ot_equipment',
            }, {
                id: 1,
                name: 'qty',
                title: 'OT Equipment Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Equipment Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'ot_equipment',
            }, {
                id: 1,
                name: 'rate',
                title: 'OT Equipment Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Equipment Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'ot_equipment',
            }, {
                id: 1,
                name: 'amount',
                title: 'OT Equipment Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'OT Equipment Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'ot_equipment',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'ot_equipment',
            }]
        }
    },{
        id: 11,
        name: 'procedure_charges',
        header: 11,
        header_amount: 0,
        title: 'Procedure Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Procedure',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 11,
                    sub_header: 37,
                    name: 'routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'procedure_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: null ,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'procedure_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'procedure_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'procedure_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'procedure_charges',
                }]
            },
                {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: 11,
                    header: 11,
                    sub_header: 20,
                    name: 'ins_surgery_procedure_name',
                    title: 'Procedure',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Procedure',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'procedure_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Procedure Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Procedure Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'procedure_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Procedure Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Procedure Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'procedure_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Procedure Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Procedure Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'procedure_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'procedure_charges',
                }]
            },
        ],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 11,
                sub_header: 20,
                name: 'ins_surgery_procedure_name',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Procedure',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'procedure_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Procedure Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Procedure Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'highend',
                table: 'procedure_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Procedure Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Procedure Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'procedure_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Procedure Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Procedure Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'procedure_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'procedure_charges',
            }]
        }
    }, {
        id: 12,
        name: 'blood_bank_charges',
        header: 12,
        header_amount: 0,
        title: 'Blood Bank Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Blood Bank Component',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 12,
                    sub_header: 38 ,
                    name: 'routine',
                    title: 'Routine',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'blood_bank_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Routine Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: null ,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'blood_bank_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'blood_bank_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'blood_bank_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'blood_bank_charges',
                },]
            },
                {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: 12,
                    header: 12,
                    sub_header: 21,
                    name: 'ins_blood_components',
                    title: 'Blood Bank Charges',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Blood Bank Charges',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'blood_bank_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Blood Bank Charges Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Blood Bank Charges Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'blood_bank_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Blood Bank Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Blood Bank Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'blood_bank_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Blood Bank Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Blood Bank Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'highend',
                    table: 'blood_bank_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'highend',
                    table: 'blood_bank_charges',
                }]
            }],
            'add_more_feilds': [{
                id: 1,
                service: null,
                header: 12,
                sub_header: 21,
                name: 'ins_blood_components',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Blood Bank Charges',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'highend',
                table: 'blood_bank_charges',
            }, {
                id: 1,
                name: 'qty',
                title: 'Blood Bank Charges Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Blood Bank Charges Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'blood_bank_charges',
            }, {
                id: 1,
                name: 'rate',
                title: 'Blood Bank Charges Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Blood Bank Charges Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'blood_bank_charges',
            }, {
                id: 1,
                name: 'amount',
                title: 'Blood Bank Charges Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Blood Bank Charges Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'highend',
                table: 'blood_bank_charges',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'highend',
                table: 'blood_bank_charges',
            }]
        }
    }, {
        id: 13,
        name: 'cross_consultation_charges',
        header: 13,
        header_amount: 0,
        title: 'Cross Consultation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Cross Consultation',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 13,
                    sub_header: 22,
                    name: 'ins_dept_for_corss_consultations',
                    title: 'Select Department',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Select Department',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'cross_consultation_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Cross Consultation Charges Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Cross Consultation Charges Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'cross_consultation_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Cross Consultation Charges Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Cross Consultation Charges Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'cross_consultation_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Cross Consultation Charges Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Cross Consultation Charges Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'cross_consultation_charges',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'cross_consultation_charges',
                }]
            }],
            'add_more_feilds': [{
                id: 2,
                service: null,
                header: 13,
                sub_header: 22,
                name: 'ins_dept_for_corss_consultations',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Select Department',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'routine',
                table: 'cross_consultation_charges',
            }, {
                id: 2,
                name: 'qty',
                title: 'Cross Consultation Charges Qty.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Cross Consultation Charges Quantity',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'cross_consultation_charges',
            }, {
                id: 2,
                name: 'rate',
                title: 'Cross Consultation Charges Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Cross Consultation Charges Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'cross_consultation_charges',
            }, {
                id: 2,
                name: 'amount',
                title: 'Cross Consultation Charges Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Cross Consultation Charges Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'cross_consultation_charges',
            }, {
                id: 2,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'cross_consultation_charges',
            }]
        }
    },{
        id: 14,
        name: 'ins_hospital_services',
        header: 14,
        header_amount: 0,
        title: 'Hospital Services',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Seropsitive',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" },
            { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'mrd',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 14,
                    sub_header: 23,
                    name: 'mrd',
                    title: 'MRD',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'ins_hospital_services',
                }, {
                    id: 1,
                    name: 'qty',
                    header: 14,
                    sub_header: 23,
                    title: 'MRD Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'MRD Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ins_hospital_services',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'MRD Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'MRD Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ins_hospital_services',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'MRD Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'MRD Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ins_hospital_services',
                },{
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'ins_hospital_services',
                }]
            }, {
                'id': 2,
                'key_word': 'seropositive',
                'feilds': [{
                    id: 2,
                    service: 24,
                    header: 14,
                    sub_header: 24,
                    name: 'seropositive',
                    // title: 'Seropositive',
                    title: '',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Select Department',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12 p-0',
                    row_group: 'seropositive',
                    table: 'ins_hospital_services',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Seropositive Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Seropositive Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'seropositive',
                    table: 'ins_hospital_services',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Seropositive Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Seropositive Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'seropositive',
                    table: 'ins_hospital_services',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Seropositive Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Seropositive Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'seropositive',
                    table: 'ins_hospital_services',
                },
                {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'seropositive',
                    table: 'ins_hospital_services',
                }]
            }],
            'add_more_feilds': [{
                id: 3,
                service: null,
                header: 14,
                sub_header: 24,
                name: 'seropositive',
                // title: 'Seropositive',
                title: '',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Select Department',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                row_group: 'seropositive',
                table: 'ins_hospital_services',
            }, {
                id: 3,
                name: 'qty',
                title: 'Seropositive Quantity',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Seropositive Quantity',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'seropositive',
                table: 'ins_hospital_services',
            }, {
                id: 3,
                name: 'rate',
                title: 'Seropositive Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Seropositive Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'seropositive',
                table: 'hospital_services',
            }, {
                id: 3,
                name: 'amount',
                title: 'Seropositive Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Seropositive Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'seropositive',
                table: 'ins_hospital_services',
            },{
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'seropositive',
                table: 'ins_hospital_services',
            }]
        }
    }, {
        id: 15,
        name: 'isolation_charges',
        header: 15,
        header_amount: 0,
        title: 'Isolation Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'routine',
                'feilds': [{
                    id: 1,
                    service: null,
                    header: 15,
                    sub_header: 25,
                    name: 'ins_room_isolation_charges',
                    title: 'Room Charges',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Room Charges',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12',
                    row_group: 'ins_room_isolation_charges',
                    table: 'isolation_charges',

                }, {
                    id: 1,
                    name: 'qty',
                    title: 'Room Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'ins_room_isolation_charges',
                    table: 'isolation_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Room Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ins_room_isolation_charges',
                    table: 'isolation_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Room Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Room Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ins_room_isolation_charges',
                    table: 'isolation_charges',
                }]
            }, {
                'id': 2,
                'key_word': 'highend',
                'feilds': [{
                    id: 2,
                    service: null,
                    header: 15,
                    sub_header: 26,
                    name: 'ins_icu_isolation_charges',
                    title: 'ICU charges',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'ICU charges',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12',
                    row_group: 'ins_icu_isolation_charges',
                    table: 'isolation_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'ICU Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'ins_icu_isolation_charges',
                    table: 'isolation_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'ICU Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ins_icu_isolation_charges',
                    table: 'isolation_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'ICU Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'ICU Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ins_icu_isolation_charges',
                    table: 'isolation_charges',
                }]
            }]
        }
    },{
        id: 16,
        name: 'ins_physiotherapy_diet_charges',
        header: 16,
        header_amount: 0,
        title: 'Physiotherapy & Diet Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Physiotherapy',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "30%" }, { 'id': 3, 'text': 'Quantity', width: "15%" }, { 'id': 4, 'text': 'Rate (Rs.)', width: "15%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "28%" },{ 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [
                {
                'id': 1,
                'key_word': 'dietician',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 16,
                    sub_header: 27,
                    name: 'dietician',
                    title: 'Dietician',
                    visible: true,
                    element: 'text',
                    row_group: 'dietician',
                    tooltip:null,
                    table: 'ins_physiotherapy_diet_charges',
                }, {
                    id: 1,
                    name: 'qty',
                    header: 16,
                    sub_header: 27,
                    title: 'Dietician Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Dietician Quantity',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'dietician',
                    table: 'ins_physiotherapy_diet_charges',
                }, {
                    id: 1,
                    name: 'rate',
                    title: 'Dietician Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Dietician Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'dietician',
                    table: 'ins_physiotherapy_diet_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Dietician Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Dietician Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'dietician',
                    table: 'ins_physiotherapy_diet_charges',
                },
                {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'dietician',
                    table: 'ins_physiotherapy_diet_charges',
                }]
            },{
                'id': 2,
                'key_word': 'routine',
                'feilds': [{
                    id: 2,
                    service: 1,
                    header: 16,
                    sub_header: 39,
                    name: 'routine',
                    title: 'Physiotherapy Routine',
                    visible: true,
                    element: 'text',
                    tooltip:null,
                    row_group: 'routine',
                    table: 'ins_physiotherapy_diet_charges',
                }, {
                    id: 2,
                    name: 'qty',
                    title: 'Routine Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine',
                    rules: [],
                    errors: [],
                    value: null ,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ins_physiotherapy_diet_charges',
                }, {
                    id: 2,
                    name: 'rate',
                    title: 'Routine Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ins_physiotherapy_diet_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Routine Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Routine Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ins_physiotherapy_diet_charges',
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'ins_physiotherapy_diet_charges',
                },]
            },
             {
                'id': 3,
                'key_word': 'highend',
                'feilds': [{
                    id: 3,
                    service: null,
                    header: 16,
                    sub_header: 28,
                    name: 'ins_physiotherapys',
                    title: 'Physiotherapy',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'select',
                    placeholder: 'Physiotherapy',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'ins_physiotherapys',
                    table: 'ins_physiotherapy_diet_charges',

                }, {
                    id: 3,
                    name: 'qty',
                    title: 'Physiotherapy Quantity',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physiotherapy Quantity',
                    rules: [],
                    errors: [],
                    value: 1,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'ins_physiotherapys',
                    table: 'ins_physiotherapy_diet_charges',
                }, {
                    id: 3,
                    name: 'rate',
                    title: 'Physiotherapy Rate',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physiotherapy Rate',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ins_physiotherapys',
                    table: 'ins_physiotherapy_diet_charges',
                }, {
                    id: 3,
                    name: 'amount',
                    title: 'Physiotherapy Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physiotherapy Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'ins_physiotherapys',
                    table: 'ins_physiotherapy_diet_charges',
                },{
                    id: 3,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'ins_physiotherapys',
                    table: 'ins_physiotherapy_diet_charges',
                }]
            }],
            'add_more_feilds': [{
                id: 4,
                service: null,
                header: 16,
                sub_header: 28,
                name: 'ins_physiotherapys',
                title: 'Physiotherapy',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'select',
                placeholder: 'Physiotherapy',
                rules: [],
                errors: [],
                value: 1,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'ins_physiotherapys',
                table: 'ins_physiotherapy_diet_charges',

            }, {
                id: 4,
                name: 'qty',
                title: 'Physiotherapy Quantity',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Physiotherapy Quantity',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'ins_physiotherapys',
                table: 'ins_physiotherapy_diet_charges',
            }, {
                id: 4,
                name: 'rate',
                title: 'Physiotherapy Rate',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Physiotherapy Rate',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'ins_physiotherapys',
                table: 'ins_physiotherapy_diet_charges',
            }, {
                id: 4,
                name: 'amount',
                title: 'Physiotherapy Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Physiotherapy Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'ins_physiotherapys',
                table: 'ins_physiotherapy_diet_charges',
            },{
                id: 4,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'ins_physiotherapys',
                table: 'ins_physiotherapy_diet_charges',
            }]
        }
    },
    {
        id: 17,
        name: 'ins_surgical_charges',
        header: 17,
        header_amount: 0,
        title: 'Surgical Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "40%" },{ 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'additional_surgeon_fees',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 17,
                    sub_header: 42,
                    name: 'additional_surgeon_fees',
                    title: 'Additional Surgeon Fees',
                    visible: true,
                    element: 'text',
                }, {
                    id: 1,
                    name: 'percentage',
                    title: 'Surgeon Amount',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'additional_surgeon_fees',
                    table: 'ins_surgical_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Surgeon Percentage',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'additional_surgeon_fees',
                    table: 'ins_surgical_charges',
                }]
            },
                {
                'id': 2,
                'key_word': 'surgeon',
                'feilds': [{
                    id: 2,
                    service: 1,
                    header: 17,
                    sub_header: 29,
                    name: 'surgeon',
                    title: 'Surgeon',
                    visible: true,
                    element: 'text',
                }, {
                    id: 2,
                    name: 'percentage',
                    title: 'Surgeon Amount',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'surgeon',
                    table: 'ins_surgical_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Surgeon Percentage',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'surgeon',
                    table: 'ins_surgical_charges',
                }]
            }, {
                'id': 3,
                'key_word': 'asst_surgeon',
                'feilds': [{
                    id: 3,
                    service: 2,
                    header: 17,
                    sub_header: 30,
                    name: 'asst_surgeon',
                    title: 'Asst Surgeon',
                    visible: true,
                    element: 'text',

                }, {
                    id: 3,
                    name: 'percentage',
                    title: 'Asst Surgeon Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Surgeon Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'surgeon',
                    table: 'ins_surgical_charges',
                }, {
                    id: 3,
                    name: 'amount',
                    title: 'Asst Surgeon Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Surgeon Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'asst_surgeon',
                    table: 'ins_surgical_charges',
                }]
            }, {
                'id': 4,
                'key_word': 'anaesthetist',
                'feilds': [{
                    id: 4,
                    service: 3,
                    header: 17,
                    sub_header: 31,
                    name: 'anaesthetist',
                    title: 'Anaesthetist',
                    visible: true,
                    element: 'text',

                }, {
                    id: 4,
                    name: 'percentage',
                    title: 'Anaesthetist Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Surgeon Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'surgeon',
                    table: 'ins_surgical_charges',
                }, {
                    id: 4,
                    name: 'amount',
                    title: 'Anaesthetist Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Anaesthetist Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'anaesthetist',
                    table: 'ins_surgical_charges',
                }]
            }
            // , 
            // {
            //     'id': 4,
            //     'key_word': 'asst_anaesthetist',
            //     'feilds': [{
            //         id: 4,
            //         service: 4,
            //         header: 17,
            //         sub_header: 32,
            //         name: 'asst_anaesthetist',
            //         title: 'Asst Anaesthetist',
            //         visible: true,
            //         element: 'text',

            //     }, {
            //         id: 4,
            //         name: 'percentage',
            //         title: 'Asst Anaesthetist Percentage',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'number',
            //         placeholder: 'Surgeon Percentage',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: true,
            //         className: 'col-3',
            //         row_group: 'surgeon',
            //         table: 'ins_surgical_charges',
            //     }, {
            //         id: 4,
            //         name: 'amount',
            //         title: 'Asst Anaesthetist Amount',
            //         visible: true,
            //         icon: 'number',
            //         element: 'input',
            //         required: true,
            //         type: 'number',
            //         placeholder: 'Asst Anaesthetist Amount',
            //         rules: [],
            //         errors: [],
            //         value: null,
            //         valid: false,
            //         state: '',
            //         disable: true,
            //         className: 'col-3',
            //         row_group: 'asst_anaesthetist',
            //         table: 'ins_surgical_charges',
            //     }]
            // }
            ]
        }
    }, {
        id: 18,
        name: 'ins_medical_charges',
        header: 18,
        header_amount: 0,
        title: 'Medical Charges',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': false,
            'add_more_title': null,
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "40%" }, { 'id': 5, 'text': 'Amount (Rs.)', width: "35%" }],
            'table_body': [{
                'id': 1,
                'key_word': 'physician_fees',
                'feilds': [{
                    id: 1,
                    service: 1,
                    header: 18,
                    sub_header: 33,
                    name: 'physician_fees',
                    title: 'Physician Fees',
                    visible: true,
                    element: 'text',
                }, {
                    id: 1,
                    name: 'percentage',
                    title: 'Physician Fees Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physician Fees Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'physician_fees',
                    table: 'ins_medical_charges',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Physician Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Physician Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'physician_fees',
                    table: 'ins_medical_charges',
                }]
            }, {
                'id': 2,
                'key_word': 'in_asst_physician_fees',
                'feilds': [{
                    id: 2,
                    service: 2,
                    header: 18,
                    sub_header: 34,
                    name: 'asst_physician_fees',
                    title: 'Asst Physician Fees',
                    visible: true,
                    element: 'text',

                }, {
                    id: 2,
                    name: 'percentage',
                    title: 'Asst Physician Fees Percentage',
                    visible: false,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Physician Fees Percentage',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'asst_physician_fees',
                    table: 'ins_medical_charges',
                }, {
                    id: 2,
                    name: 'amount',
                    title: 'Asst Physician Amount',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Asst Physician Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'asst_physician_fees',
                    table: 'ins_medical_charges',
                }]
            }]
        }
    }]
}


const additionalProcedureSchema = {
    feilds: [{
        id: 1,
        name: 'additional_procedure',
        title: 'Additional Procedure',
        visible: false,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Additional Procedure',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Procedure Name', width: "20%" }, { 'id': 4, 'text': 'Amount (Rs.)', width: "25%" }, { 'id': 6, 'text': 'Action', width: "5%" }],
            'table_body': [],
            'add_more_feilds': [{
                id: 1,
                name: 'ins_add_procedure_name',
                service: 11,
                header: 11,
                sub_header: 20,
                title: 'Procedure Name',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'number',
                placeholder: 'Select',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'additional_procedure',
            }, {
                id: 1,
                name: 'amount',
                title: 'Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'additional_procedure',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'additional_procedure'
            }],
        }
    },]
}
const additionalPackageSchema = {
    feilds: [{
        id: 1,
        name: 'additional_package',
        title: 'Additional package',
        visible: false,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Additional package',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Package Name', width: "30%" },{ 'id': 3, 'text': 'Actual Price(Rs.)', width: "20%" },{ 'id': 4, 'text': 'Percentage(%)', width: "10%" },{ 'id': 5, 'text': 'Discount Price(Rs.)', width: "20%" }, { 'id': 6, 'text': 'Action', width: "5%" }],
            'table_body': [],
            'add_more_feilds': [{
                id: 1,
                name: 'ins_additional_package_name',
                title: 'package Name',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'number',
                placeholder: 'Select',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'additional_package',
            },
            {
                id: 1,
                name: 'actualprice',
                title: 'Actual Price',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'additional_package',
            },
            {
                id: 1,
                name: 'percentage',
                title: 'Percentage',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Percentage',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'additional_package',
            },  {
                id: 1,
                name: 'amount',
                title: 'Amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'additional_package',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'additional_package',
            }],
        }
    },]
}

const preexistingConditionsSchema = {
    feilds: [{
        id: 1,
        name: 'pre_ex_conditions',
        title: 'Pre-Existing Conditions',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Pre-Existing Condition',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Condition', width: "20%" }, { 'id': 3, 'text': 'Onset Date', width: "25%" }, { 'id': 4, 'text': 'Sum Insured At Onset Date', width: "25%" }, { 'id': 4, 'text': 'Consider SI', width: "25%" }, { 'id': 6, 'text': 'Action', width: "5%" }],
            'table_body': [{
                'id': 1,
                'feilds': [{
                    id: 1,
                    name: 'pre_ex_condition_name',
                    title: 'Condition',
                    visible: true,
                    icon: 'number',
                    element: 'select',
                    required: true,
                    type: 'number',
                    placeholder: 'Select',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'pre_ex_conditions',
                }, {
                    id: 1,
                    name: 'onset_date',
                    title: 'Onset Date',
                    visible: true,
                    icon: 'number',
                    element: 'datepicker',
                    required: true,
                    type: 'datepicker',
                    placeholder: 'Select',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'pre_ex_conditions',
                }, {
                    id: 1,
                    name: 'sum_insured_onset_Date',
                    title: 'Sum Insured Onset Date',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'number',
                    placeholder: 'Enter',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'pre_ex_conditions',
                }, {
                    id: 1,
                    name: 'consider_si',
                    title: 'Consider SI',
                    visible: true,
                    icon: 'number',
                    element: 'checkbox',
                    required: true,
                    type: 'checkbox',
                    placeholder: 'Consider',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'pre_ex_conditions',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',

                },]
            }, {
                'id': 2,

                'feilds': [{
                    id: 2,
                    name: 'sum_insured_for_four_years_back_text',
                    title: 'Sum Insured For Four Years Back',
                    visible: true,
                    element: 'text',
                    row_group: 'routine',
                    table: 'pre_ex_conditions',                    
                    colSpan: '2'
                },{
                    id: 2,
                    name: 'sum_insured_for_four_years_back',
                    title: 'Sum Insured For Four Years Back',
                    visible: true,
                    icon: 'number',
                    element: 'input',
                    required: true,
                    type: 'text',
                    placeholder: 'Sum Insured For Four Years Back',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'pre_ex_conditions'
                }, {
                    id: 2,
                    name: 'consider_si',
                    title: 'Consider SI',
                    visible: true,
                    icon: 'number',
                    element: 'checkbox',
                    required: true,
                    type: 'checkbox',
                    placeholder: 'Consider',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'pre_ex_conditions'
                }, {
                    id: 2,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'text',

                }]
            }],
            'add_more_feilds': [{
                id: 1,
                name: 'pre_ex_condition_name',
                title: 'Condition',
                visible: true,
                icon: 'number',
                element: 'select',
                required: true,
                type: 'number',
                placeholder: 'Select',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'pre_ex_conditions',
            }, {
                id: 1,
                name: 'onset_date',
                title: 'Onset Date',
                visible: true,
                icon: 'number',
                element: 'datepicker',
                required: true,
                type: 'datepicker',
                placeholder: 'Select',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'pre_ex_conditions',
            }, {
                id: 1,
                name: 'sum_insured_onset_Date',
                title: 'Sum Insured Onset Date',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Enter',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'pre_ex_conditions',
            }, {
                id: 1,
                name: 'consider_si',
                title: 'Consider SI',
                visible: true,
                icon: 'number',
                element: 'checkbox',
                required: true,
                type: 'checkbox',
                placeholder: 'Consider',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'pre_ex_conditions',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'pre_ex_conditions',
            }],

        },
    }]
}

const interimSchema = {
    feilds: [{
        id: 1,
        name: 'interim',
        title: 'Interim Approval',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Interim',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 3, 'text': 'Interim Approval amount', width: "25%" }, { 'id': 4, 'text': 'Approx Bill amount', width: "25%" }, { 'id': 4, 'text': 'Case no.', width: "20%" }, { 'id': 6, 'text': 'Action', width: "5%" }],
            'table_body': [],
            'add_more_feilds': [{
                id: 1,
                name: 'interim_approval_amount',
                title: 'Interim Approval amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Interim Approval amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'interim',
            }, {
                id: 1,
                name: 'approx_bill_amount',
                title: 'Approx Bill amount',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Approx Bill amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'interim',
            }, {
                id: 1,
                name: 'case_no',
                title: 'Case No.',
                visible: true,
                icon: 'number',
                element: 'input',
                required: true,
                type: 'number',
                placeholder: 'Case No.',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'interim',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'interim',

            }],
        }
    },]
}

const basicSumInsuredSchema = Object.seal({
    feilds: [{
        id: 28,
        name: 'basic_sum_insured',
        title: 'Basic Sum Insured *',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Basic Sum Insured'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 mt-3'
    }, {
        id: 29,
        name: 'top_up_amount',
        title: 'Top Up Amount (Rs.) *',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Top UP Amount'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 mt-3'
    }, {
        id: 30,
        name: 'balance_sum_insured',
        title: 'Balance Sum Insured *',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Bal Sum Insured'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 mt-3'
    }, {
        id: 32,
        type: "group",
        name: 'ins_co_pay',
        element: 'input2',
        visible: true,
        title: 'Co-pay (%) / Amount (Rs.)',
        data: [{
            id: 18,
            name: 'ins_copay_percent',
            title: '',
            visible: true,
            element: 'input',
            required: true,
            type: 'number',
            placeholder: '%',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Copay Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-6 p-0'
        }, {
            id: 18,
            type: "group",
            name: 'ins_copay_amount',
            title: '',
            visible: true,
            element: 'input',
            required: true,
            type: 'number',
            placeholder: 'Amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Copay Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-6 p-0'
        }],
        className: 'col-4'
    }, {
        id: 22,
        type: "group",
        name: 'ins_room_eligible',
        // name: 'ins_room_eligible_percent'
        element: 'input2',
        visible: true,
        title: 'Room Eligibility(%)*/Amount(Rs.)',
        data: [{
            id: 18,
            name: 'ins_room_eligible_percent',
            title: '',
            visible: true,
            element: 'input',
            required: true,
            type: 'number',
            placeholder: '%',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return (value !== null && value.length > 0);
                        // return true;
                    },
                    message: 'Please Enter Room Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-6 p-0'
        }, {
            id: 18,
            type: "group",
            name: 'ins_room_eligible_amount',
            title: '',
            visible: true,
            element: 'input',
            required: true,
            type: 'number',
            placeholder: 'Amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility amount'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-6 p-0'
        }],
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Room Eligibility %'
            }
        ],
        className: 'col-4'
    }, {
        id: 3,
        name: 'ins_room_eligible_ward',
        type: "group",
        title: 'Room Eligibility Ward/Amount(Rs.)',
        visible: true,
        element: 'select3',
        data: [{
            id: 3,
            name: 'ins_room_eligible_ward_names',
            title: '',
            visible: true,
            element: 'select2',
            required: true,
            type: 'select',
            placeholder: 'Select',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility Ward'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-6 pl-0 pr-0'
        }, {
            id: 3,
            name: 'ins_room_eligible_ward_amount',
            title: '',
            visible: true,
            element: 'input',
            required: true,
            type: 'number',
            placeholder: 'Amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility Ward'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-6 pl-0'
        }],
        className: 'col-4'
    }, {
        id: 5,
        type: "group",
        name: 'ins_upgrade_room',
        title: 'Room Upgrade Ward/Amount(Rs.)',
        visible: true,
        element: 'select3',
        data: [{
            id: 3,
            name: 'ins_upgrade_room_names',
            title: '',
            visible: true,
            element: 'select2',
            required: true,
            type: 'select',
            placeholder: 'Select',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility Ward'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-6 pl-0 pr-0'
        }, {
            id: 3,
            name: 'ins_upgrade_room_amount',
            title: '',
            visible: true,
            element: 'input',
            required: true,
            type: 'number',
            placeholder: 'Amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility Ward'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-6 pl-0'
        }],
        className: 'col-4'
    }, {
        id: 35,
        name: 'ins_room_upgrade_reason',
        title: 'Room Upgrade Reason *',
        visible: false,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Upgrade Reason'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 mt-3'
    }, {
        id: 9,
        type: "group",
        name: 'ins_icu_eligible',
        title: 'ICU Eligibility (%)* / Amount (Rs.)',
        visible: true,
        element: 'input2',
        data: [{
            id: 18,
            name: 'ins_icu_percent',
            title: '',
            visible: true,
            element: 'input',
            required: true,
            type: 'number',
            placeholder: '%',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-6 p-0'
        }, {
            id: 18,
            name: 'ins_icu_amount',
            title: '',
            visible: true,
            element: 'input',
            required: true,
            type: 'number',
            placeholder: 'Amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter Room Eligibility %'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-6 p-0'
        }],
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    // return true;
                },
                message: 'Please Enter Room Eligibility %'
            }
        ],
        className: 'col-4'
    }, {
        id: 54,
        type: "group",
        name: 'ins_icu',
        title: 'ICU Type / Amount (Rs.)',
        visible: true,
        element: 'select3',
        data: [{
            id: 3,
            name: 'ins_icu_type',
            title: '',
            visible: true,
            element: 'select2',
            required: true,
            type: 'select',
            placeholder: 'select',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter ICU Type'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-6 pl-0 pr-0'
        }, {
            id: 3,
            name: 'ins_icu_amount',
            title: '',
            visible: true,
            element: 'input',
            required: true,
            type: 'number',
            placeholder: 'Amount',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        //return (value !== null && value.length > 0);
                        return true;
                    },
                    message: 'Please Enter ICU Amount'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: true,
            className: 'col-6 pl-0'
        }],
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    // return true;
                },
                message: 'Please Select ICU Type'
            }
        ],
        className: 'col-4'
    }, {
        id: 40,
        name: 'ins_icu_difference',
        title: 'ICU Difference',
        visible: true,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 mt-3'
    }, {
        id: 41,
        name: 'ins_select_difference',
        title: 'Select Difference *',
        visible: false,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && value != '');
                },
                message: 'Please Select Difference'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 mt-3'
    }, {
        id: 42,
        name: 'ins_room_difference_amount',
        title: 'Room and ICU Difference Amount (Rs.)',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4 mt-3'
    }, {
        id: 43,
        name: 'ins_pro_rata_difference_amount',
        title: 'Pro Rata Difference Amount (Rs.)',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-4 mt-3'
    }, {
        id: 44,
        name: 'ins_package_difference',
        title: 'Package Difference',
        visible: false,
        element: 'input',
        required: false,
        type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 mt-3'
    }, {
        id: 45,
        name: 'ins_ailment_capping',
        title: 'Ailment Capping ',
        visible: true,
        element: 'select',
        required: false,
        type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [],
        errors: [],
        value: 2,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4 mt-3'
    },]
})

const ailmentSchema = {
    feilds: [{
        id: 1,
        name: 'ailment_capping',
        title: 'Ailment Capping',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add Ailment Capping',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Surgery / Procedure', width: "61%" }, { 'id': 4, 'text': 'Amount (Rs.)', width: "28%" }, { 'id': 6, 'text': 'Action', width: "7%" }],
            'table_body': [{
                'id': 1,
                'feilds': [{
                    id: 1,
                    name: 'ins_ail_surgery_procedure_name',
                    service: 11,
                    header: 11,
                    sub_header: 20,
                    title: 'Surgery / Procedure (Capped ailment)',
                    visible: true,
                    element: 'select',
                    required: false,
                    type: 'select',
                    placeholder: 'Select',
                    icon: 'user',
                    rules: [{
                        test: (value) => {
                            return (value !== null && value.length > 0 && value != '');
                        },
                        message: 'Select Surgery / Procedure (Capped ailment)'
                    }],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ailment_capping',
                }, {
                    id: 1,
                    name: 'amount',
                    title: 'Amount',
                    visible: true,
                    element: 'input',
                    required: false,
                    type: 'number',
                    placeholder: 'Enter',
                    icon: 'user',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: true,
                    className: 'col-3',
                    row_group: 'routine',
                    table: 'ailment_capping',
                }, {
                    id: 1,
                    name: 'action',
                    title: '--',
                    visible: true,
                    element: 'action',
                    row_group: 'routine',
                table: 'ailment_capping',

                }]
            }
            ],
            'add_more_feilds': [{
                id: 1,
                name: 'ins_ail_surgery_procedure_name',                
                service: 11,
                header: 11,
                sub_header: 20,
                title: 'Surgery / Procedure (Capped ailment)',
                visible: true,
                element: 'select',
                required: false,
                type: 'select',
                placeholder: 'Select',
                icon: 'user',
                rules: [{
                    test: (value) => {
                        return (value !== null && value.length > 0 && value != '');
                    },
                    message: 'Select Surgery / Procedure (Capped ailment)'
                }],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'routine',
                table: 'ailment_capping',
            }, {
                id: 1,
                name: 'amount',
                title: 'Amount',
                visible: true,
                element: 'input',
                required: false,
                type: 'number',
                placeholder: 'Enter',
                icon: 'user',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: true,
                className: 'col-3',
                row_group: 'routine',
                table: 'ailment_capping',
            }, {
                id: 1,
                name: 'action',
                title: '--',
                visible: true,
                element: 'action',
                row_group: 'routine',
                table: 'ailment_capping',

            }],
        }
    },]
}

// const nmePopupSchema = {
//     feilds: [{
//         id: 1,
//         name: 'nme',
//         title: 'NME',
//         visible: true,
//         Specification: {
//             'type': 'table',
//             'add_more': true,
//             'add_more_title': 'Add NME',
//             'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Service Name', width: "15%" }, { 'id': 3, 'text': 'Description', width: "50%" },  { 'id': 5, 'text': 'Amount (Rs.)', width: "20%" }],
//             'table_body': [{
//                 'id': 1,
//                 'text': 'item_service',
//                 'type': 'Item / Service',
//                 'input_feild': [],
//                 'feilds': [{
//                     id: 1,
//                 name: 'nmename',
//                 title: '',
//                 visible: true,
//                 icon: 'number',
//                 element: 'text',
//                 required: true,
//                 type: 'select',
//                 placeholder: 'Item / Service Choose',
//                 rules: [],
//                 errors: [],
//                 value: null,
//                 valid: false,
//                 state: '',
//                 disable: false,
//                 className: 'col-12 p-0',
//                 column_group: 'choose',
//                 table: 'nme',

//                 }, 
//                 {
//                     id: 1,
//                 name: 'description',
//                 title: '',
//                 visible: true,
//                 icon: 'number',
//                 element: 'text',
//                 required: true,
//                 type: 'select',
//                 placeholder: 'Item / Service Choose',
//                 rules: [],
//                 errors: [],
//                 value: null,
//                 valid: false,
//                 state: '',
//                 disable: false,
//                 className: 'col-12 p-0',
//                 column_group: 'choose',
//                 table: 'nme',

//                 },  {
//                     id: 1,
//                     name: 'amount',
//                     title: 'Item / Service Amount',
//                     visible: true,
//                     icon: 'number',
//                     element: 'text',
//                     required: true,
//                     type: 'number',
//                     placeholder: 'Item / Service Amount',
//                     rules: [],
//                     errors: [],
//                     value: null,
//                     valid: false,
//                     state: '',
//                     disable: false,
//                     className: 'col-3',
//                     row_group: 'Routine',
//                     column_group: 'amount',
//                     table: 'nme',
//                 },
//                 {
//                     id: 1,
//                     name: 'total',
//                     title: 'Item / Service Amount',
//                     visible: true,
//                     icon: 'number',
//                     element: 'input',
//                     required: true,
//                     type: 'number',
//                     placeholder: 'Item / Service Amount',
//                     rules: [],
//                     errors: [],
//                     value: null,
//                     valid: false,
//                     state: '',
//                     disable: false,
//                     className: 'col-3',
//                     row_group: 'Routine',
//                     column_group: 'amount',
//                     table: 'nme',
//                 }, ]
//             }],

//             'add_more_feilds': [{
//                 id: 1,
//                 name: 'nmename',
//                 title: '',
//                 visible: true,
//                 icon: 'number',
//                 element: 'text',
//                 required: true,
//                 type: 'select',
//                 placeholder: 'Item / Service Choose',
//                 rules: [],
//                 errors: [],
//                 value: null,
//                 valid: false,
//                 state: '',
//                 disable: false,
//                 className: 'col-12 p-0',
//                 row_group: 'Highend',
//                 column_group: 'choose',
//                 table: 'nme',
//             },{
//                 id: 1,
//             name: 'description',
//             title: '',
//             visible: true,
//             icon: 'number',
//             element: 'text',
//             required: true,
//             type: 'select',
//             placeholder: 'Item / Service Choose',
//             rules: [],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-12 p-0',
//             column_group: 'choose',
//             table: 'nme',

//             },{
//                 id: 1,
//                 name: 'amount',
//                 title: 'Item / Service Amount',
//                 visible: true,
//                 icon: 'number',
//                 element: 'text',
//                 required: true,
//                 type: 'number',
//                 placeholder: 'Item / Service Amount',
//                 rules: [],
//                 errors: [],
//                 value: null,
//                 valid: false,
//                 state: '',
//                 disable: false,
//                 className: 'col-3',
//                 row_group: 'Highend',
//                 column_group: 'amount',
//                 table: 'nme',
//             },
//             {
//                 id: 1,
//                 name: 'total',
//                 title: 'Item / Service Amount',
//                 visible: true,
//                 icon: 'number',
//                 element: 'input',
//                 required: true,
//                 type: 'number',
//                 placeholder: 'Item / Service Amount',
//                 rules: [],
//                 errors: [],
//                 value: null,
//                 valid: false,
//                 state: '',
//                 disable: false,
//                 className: 'col-3',
//                 row_group: 'Routine',
//                 column_group: 'amount',
//                 table: 'nme',
//             },],
//         }
//     }]
// }

const nmePopupSchema = {
    feilds: [{
        id: 1,
        name: 'nme',
        title: 'NME',
        visible: true,
        Specification: {
            'type': 'table',
            'add_more': true,
            'add_more_title': 'Add NME',
            'table_head': [{ 'id': 1, 'text': 'S.no', width: "5%" }, { 'id': 2, 'text': 'Unit Name', width: "15%" },{ 'id': 2, 'text': 'Department', width: "15%" }, { 'id': 3, 'text': 'Description', width: "25%" },{ 'id': 2, 'text': 'Tariff', width: "15%" },{ 'id': 2, 'text': 'Rate', width: "15%" },  { 'id': 5, 'text': 'Amount (Rs.)', width: "8%" }],
            'table_body': [{
                'id': 1,
                'text': 'item_service',
                'type': 'Item / Service',
                'input_feild': [],
                'feilds': [
                    {
                        id: 1,
                    name: 'nme_id',
                    title: '',
                    visible: false,
                    icon: 'number',
                    element: 'text',
                    required: true,
                    type: 'select',
                    placeholder: 'Item / Service Choose',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-12 p-0',
                    column_group: 'choose',
                    table: 'nme',
        
                    },
                    {
                    id: 1,
                name: 'unit',
                title: '',
                visible: true,
                icon: 'number',
                element: 'text',
                required: true,
                type: 'select',
                placeholder: 'Item / Service Choose',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                column_group: 'choose',
                table: 'nme',

                }, 
                {
                    id: 1,
                name: 'department',
                title: '',
                visible: true,
                icon: 'number',
                element: 'text',
                required: true,
                type: 'select',
                placeholder: 'Item / Service Choose',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                column_group: 'choose',
                table: 'nme',

                },  {
                    id: 1,
                    name: 'description',
                    title: 'Item / Service Amount',
                    visible: true,
                    icon: 'number',
                    element: 'text',
                    required: true,
                    type: 'number',
                    placeholder: 'Item / Service Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Routine',
                    column_group: 'amount',
                    table: 'nme',
                }, 
                {
                    id: 1,
                    name: 'tariff',
                    title: 'Item / Service Amount',
                    visible: true,
                    icon: 'number',
                    element: 'text',
                    required: true,
                    type: 'number',
                    placeholder: 'Item / Service Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Routine',
                    column_group: 'amount',
                    table: 'nme',
                }, 
                {
                    id: 1,
                    name: 'rate',
                    title: 'Item / Service Amount',
                    visible: true,
                    icon: 'number',
                    element: 'text',
                    required: true,
                    type: 'number',
                    placeholder: 'Item / Service Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Routine',
                    column_group: 'amount',
                    table: 'nme',
                }, 
                {
                    id: 1,
                    name: 'amount',
                    title: 'Item / Service Amount',
                    visible: true,
                    icon: 'number',
                    element: 'text',
                    required: true,
                    type: 'number',
                    placeholder: 'Item / Service Amount',
                    rules: [],
                    errors: [],
                    value: null,
                    valid: false,
                    state: '',
                    disable: false,
                    className: 'col-3',
                    row_group: 'Highend',
                    column_group: 'amount',
                    table: 'nme',
                },
                // {
                //     id: 1,
                //     name: 'total',
                //     title: 'Item / Service Amount',
                //     visible: true,
                //     icon: 'number',
                //     element: 'input',
                //     required: true,
                //     type: 'number',
                //     placeholder: 'Item / Service Amount',
                //     rules: [],
                //     errors: [],
                //     value: null,
                //     valid: false,
                //     state: '',
                //     disable: false,
                //     className: 'col-3',
                //     row_group: 'Routine',
                //     column_group: 'amount',
                //     table: 'nme',
                // },
            ]
            }],

            'add_more_feilds':  [
                {
                    id: 1,
                name: 'nme_id',
                title: '',
                visible: false,
                icon: 'number',
                element: 'text',
                required: true,
                type: 'select',
                placeholder: 'Item / Service Choose',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-12 p-0',
                column_group: 'choose',
                table: 'nme',
    
                },{
                id: 1,
            name: 'unit',
            title: '',
            visible: true,
            icon: 'number',
            element: 'text',
            required: true,
            type: 'select',
            placeholder: 'Item / Service Choose',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-12 p-0',
            column_group: 'choose',
            table: 'nme',

            }, 
            {
                id: 1,
            name: 'department',
            title: '',
            visible: true,
            icon: 'number',
            element: 'text',
            required: true,
            type: 'select',
            placeholder: 'Item / Service Choose',
            rules: [],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-12 p-0',
            column_group: 'choose',
            table: 'nme',

            },  {
                id: 1,
                name: 'description',
                title: 'Item / Service Amount',
                visible: true,
                icon: 'number',
                element: 'text',
                required: true,
                type: 'number',
                placeholder: 'Item / Service Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'Routine',
                column_group: 'amount',
                table: 'nme',
            }, 
            {
                id: 1,
                name: 'tariff',
                title: 'Item / Service Amount',
                visible: true,
                icon: 'number',
                element: 'text',
                required: true,
                type: 'number',
                placeholder: 'Item / Service Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'Routine',
                column_group: 'amount',
                table: 'nme',
            }, 
            {
                id: 1,
                name: 'rate',
                title: 'Item / Service Amount',
                visible: true,
                icon: 'number',
                element: 'text',
                required: true,
                type: 'number',
                placeholder: 'Item / Service Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'Routine',
                column_group: 'amount',
                table: 'nme',
            }, 
            {
                id: 1,
                name: 'amount',
                title: 'Item / Service Amount',
                visible: true,
                icon: 'number',
                element: 'text',
                required: true,
                type: 'number',
                placeholder: 'Item / Service Amount',
                rules: [],
                errors: [],
                value: null,
                valid: false,
                state: '',
                disable: false,
                className: 'col-3',
                row_group: 'Highend',
                column_group: 'amount',
                table: 'nme',
            },
            // {
            //     id: 1,
            //     name: 'total',
            //     title: 'Item / Service Amount',
            //     visible: true,
            //     icon: 'number',
            //     element: 'input',
            //     required: true,
            //     type: 'number',
            //     placeholder: 'Item / Service Amount',
            //     rules: [],
            //     errors: [],
            //     value: null,
            //     valid: false,
            //     state: '',
            //     disable: false,
            //     className: 'col-3',
            //     row_group: 'Routine',
            //     column_group: 'amount',
            //     table: 'nme',
            // },
            ]
        }
    }]
}



export { InsuranceDetailsSchema, estimateBreakupFormatSchema, addonSchema, basicDetailsSchema, additionalProcedureSchema, preexistingConditionsSchema, basicSumInsuredSchema, ailmentSchema, interimSchema, nmePopupSchema, additionalPackageSchema };